package com.vizio.redwolf.utils

enum class EnvironmentGroup {
    PROD,
    PREPROD,
    STAGE,
    DEV,
    TEST;

    companion object {
        fun byName(name: String): EnvironmentGroup = entries.firstOrNull { it.name == name.uppercase() } ?: throw Exception("Please specify environment in CI/CD via gradle environment!")
    }
}
